import * as utils from './utils';
export function getDeclarations(node) {
    const declarations = utils.getValueOrUndefined(node.declarations);
    return declarations === undefined ? [] : declarations;
}
export function getDeclarationList(node) {
    return node.declarationList;
}
export function getDeclarationsFromStatement(node) {
    return getDeclarations(getDeclarationList(node));
}

//# sourceMappingURL=variable.js.map
